<template>
  <span>
    <span
      :class="textClass"
      :id="`copy-tooltip-${uniqueId}`"
      @click.stop="copyText(text)"
    >
      {{ text }}
    </span>
    <b-tooltip :target="`copy-tooltip-${uniqueId}`">
      <div v-if="copiedItemId === uniqueId" class="flex-center">
        <span class="color-success margin-left-8">
          <mdicon name="check-circle-outline" size="16" />
        </span>
        {{ "کپی شد" }}
      </div>
      <div v-else class="flex-center">
        <span class="margin-left-8">
          <mdicon name="content-copy" size="16" />
        </span>
        {{ "کلیک برای کپی" }}
      </div>
    </b-tooltip>
  </span>
</template>

<script>
import { ref, toRef, toRefs } from "vue";
import { v4 as uuid } from "uuid";
import { copy } from "@/shared/utils";
export default {
  props: {
    text: {
      type: [String, Number],
      default: "",
    },
    textClass: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const { text } = toRefs(props);
    const uniqueId = uuid();

    const copiedItemId = ref(null);
    const copyText = () => {
      copy(text.value);
      copiedItemId.value = uniqueId;
      setTimeout(() => (copiedItemId.value = null), 1000);
    };

    // return data to be used in template
    return { uniqueId, copiedItemId, copyText };
  },
};
</script>
